import { z } from "zod";
import { Form } from "src/components/common/form";
import { Input } from "src/components/common/form/input";
import { usePostBusCourseMutation } from "src/services/react-query-apis/post-bus-course";
import { usePutBusCourseMutation } from "src/services/react-query-apis/put-bus-course";
import { toast } from "react-toastify";

const courseEditInputSchema = z.object({
  code: z
    .string()
    .min(1, { message: "コースコードを入力してください" })
    .max(1, { message: "コースコードは1文字で入力してください" }),
  description: z.string().min(1, { message: "説明を入力してください" }),
});

const CourseEditForm = ({
  selectedCourse,
  formSubmitRef,
  setSelectedCourseId,
}) => {
  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      setSelectedCourseId(data.data.id);
    },
  };

  const postBusCourseMutation = usePostBusCourseMutation({
    mutationConfig,
  });

  const putBusCourseMutation = usePutBusCourseMutation({
    mutationConfig,
  });

  return (
    <Form
      onSubmit={values => {
        if (selectedCourse) {
          putBusCourseMutation.mutate({
            id: selectedCourse.id,
            ...values,
          });
        } else {
          postBusCourseMutation.mutate(values);
        }
      }}
      options={{
        defaultValues: {
          code: selectedCourse?.code || "",
          description: selectedCourse?.description || "",
        },
      }}
      schema={courseEditInputSchema}
    >
      {({ register, formState }) => {
        return (
          <>
            <div className="d-flex gap-2">
              <div className="w-25">
                <Input
                  type="text"
                  label="コースコード"
                  name="code"
                  error={formState.errors["code"]}
                  registration={register("code")}
                />
              </div>
              <div style={{ flex: 1 }}>
                <Input
                  type="text"
                  label="説明"
                  name="description"
                  error={formState.errors["description"]}
                  registration={register("description")}
                />
              </div>
              <button
                type="submit"
                ref={formSubmitRef}
                style={{ display: "none" }}
              >
                保存
              </button>
            </div>
          </>
        );
      }}
    </Form>
  );
};

export default CourseEditForm;
